import { render, staticRenderFns } from "./ForgottenPassword.vue?vue&type=template&id=17037e5a"
import script from "./ForgottenPassword.vue?vue&type=script&lang=js"
export * from "./ForgottenPassword.vue?vue&type=script&lang=js"
import style0 from "./ForgottenPassword.vue?vue&type=style&index=0&id=17037e5a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports